/**
 * CylinderMesh decode. Defaults: `primitive_meshes.h:199-205`. `set_radial_segments`
 * (`primitive_meshes.cpp:1347`) floors at 4, and `set_rings` (:1360) ERR_FAILs
 * below 0, so a negative count keeps the default. The radii and height have no
 * guard (:1300-1339), so a cone (`top_radius = 0`) is legal.
 */
import { realOr, settableIntOr } from '../../../parser/valueParsers';
import { flooredCount } from '../meshCounts';
import { boolSlotValue } from '../../../godot/variant/variantBool.js';
export function decodeCylinderMesh(properties) {
    return {
        topRadius: realOr(properties.top_radius, 0.5, 'CylinderMesh top_radius'),
        bottomRadius: realOr(properties.bottom_radius, 0.5, 'CylinderMesh bottom_radius'),
        height: realOr(properties.height, 2.0, 'CylinderMesh height'),
        radialSegments: flooredCount(properties.radial_segments, 4, 64, 'CylinderMesh radial_segments'),
        rings: settableIntOr(properties.rings, 4, { min: 0 }, 'CylinderMesh rings'),
        capTop: boolSlotValue(properties.cap_top) !== false,
        capBottom: boolSlotValue(properties.cap_bottom) !== false,
    };
}
//# sourceMappingURL=decode.js.map